import { render } from "./PromotionsManagement.html?vue&type=template&id=2289efd1&scoped=true"
import script from "./PromotionsManagement.js?vue&type=script&lang=js"
export * from "./PromotionsManagement.js?vue&type=script&lang=js"

import "./PromotionsManagement.css?vue&type=style&index=0&id=2289efd1&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/Shiptech MyPlusRewards/mpr-web-admin-portal/src/MPR.MyPlusRewardsAdminPortal.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2289efd1"]])

export default __exports__